const initialState = {
  showVFOrderSummaryFlag: false,
  accountNumber: '',
  spoId: '',
  getAvailableFeaturesAndSposResp: {},
  orderid: '',
  addFeatureResp: {},
  vfFlagCredit: false,
  // nbsResp: {},
  errorResp: {},
  isAddFeatureCompleted: false,
};

function verizonForward(state = initialState, action) {
  switch (action.type) {
    case 'SHOW_VF_ORDER_SUMMARY_PAGE': {
      return { ...state, showVFOrderSummaryFlag: action.value };
    }
    case 'SET_ACCOUNT_NUMBER': {
      return { ...state, accountNumber: action.value };
    }
    case 'SET_GET_AVAILABLE_FEATURES': {
      return { ...state, getAvailableFeaturesAndSposResp: action.value };
    }
    case 'SET_ADD_FEAT_RESP': {
      return { ...state, addFeatureResp: action.value, isAddFeatureCompleted: true };
    }
    // case 'SET_VF_FLAG_CREDIT': {
    //   return { ...state, vfFlagCredit: action.value };
    // }
    // case 'SET_NBS_RESP': {
    //   return { ...state, nbsResp: action.value };
    // }
    case 'SET_VF_ERROR_FLAG': {
      return { ...state, errorResp: action.value };
    }
    case 'SET_VFNY_ENABLE_FLAG': {
      return { ...state, isVfNyDiscountEnabled: action.value };
    }
    case 'SET_SPOID': {
      return { ...state, spoId: action.value };
    }
    case 'SET_ORDER_ID': {
      return { ...state, orderid: action.value };
    }

    default:
      return state;
  }
}

export default verizonForward;
